module.exports = __webpack_public_path__ + "img/icon2.70b902dc.png";